import { Navigate, NavLink, Route, Routes, useNavigate } from 'react-router-dom';
import { clearToken, getToken } from './api.js';
import Login from './pages/Login.js';
import Campaigns from './pages/Campaigns.js';
import CampaignNew from './pages/CampaignNew.js';
import CampaignDetail from './pages/CampaignDetail.js';
import Messages from './pages/Messages.js';
import Rules from './pages/Rules.js';
import Compare from './pages/Compare.js';
import Report from './pages/Report.js';
import Settings from './pages/Settings.js';

function Shell({ children }: { children: React.ReactNode }) {
  const nav = useNavigate();
  return (
    <div className="app">
      <aside className="sidebar">
        <div className="brand">TMT<small>SIP testing</small></div>
        <nav>
          <NavLink to="/campaigns" className={({ isActive }) => isActive ? 'active' : ''}>Campaigns</NavLink>
          <NavLink to="/messages"  className={({ isActive }) => isActive ? 'active' : ''}>Messages</NavLink>
          <NavLink to="/compare"   className={({ isActive }) => isActive ? 'active' : ''}>Compare</NavLink>
          <NavLink to="/rules"     className={({ isActive }) => isActive ? 'active' : ''}>Rules</NavLink>
          <NavLink to="/settings"  className={({ isActive }) => isActive ? 'active' : ''}>Settings</NavLink>
        </nav>
        <div className="spacer" />
        <button onClick={() => { clearToken(); nav('/login'); }}>Sign out</button>
      </aside>
      <main>{children}</main>
    </div>
  );
}

const Guard = ({ children }: { children: React.ReactNode }) =>
  getToken() ? <Shell>{children}</Shell> : <Navigate to="/login" replace />;

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/campaigns" element={<Guard><Campaigns /></Guard>} />
      <Route path="/campaigns/new" element={<Guard><CampaignNew /></Guard>} />
      <Route path="/campaigns/:id/edit" element={<Guard><CampaignNew /></Guard>} />
      <Route path="/campaigns/:id" element={<Guard><CampaignDetail /></Guard>} />
      <Route path="/campaigns/:id/report" element={<Guard><Report /></Guard>} />
      <Route path="/messages" element={<Guard><Messages /></Guard>} />
      <Route path="/compare" element={<Guard><Compare /></Guard>} />
      <Route path="/rules" element={<Guard><Rules /></Guard>} />
      <Route path="/settings" element={<Guard><Settings /></Guard>} />
      <Route path="*" element={<Navigate to="/campaigns" replace />} />
    </Routes>
  );
}
